import { LoaderCircle } from 'lucide-react';
import React, { useEffect, useState } from 'react';

export const TitleLogo = "https://ucarecdn.com/ff5f95dd-202c-47a7-a21e-f7d406a42789/-/preview/313x264/"
const Loader = () => {
  const textArray = ["Innovate...", "Automate...", "Simplify..."];
  const [displayText, setDisplayText] = useState(textArray[0]); // Initial text state

  useEffect(() => {
    const interval = setInterval(() => {
      const randomText = textArray[Math.floor(Math.random() * textArray.length)];
      setDisplayText(randomText);
    }, 1500);
    return () => clearInterval(interval);
  });

  
  return (
    <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-white z-50">
      <div className="flex flex-col justify-center items-center gap-3 relative">
        <img 
          src={TitleLogo} 
          alt="Loading icon" 
          className="w-10 h-auto opacity-50 animate-spin-slow" 
        />
        <p className="text-sm font-semibold text-gray-700 flex items-center gap-2">
        {/* <span className="w-3 h-3 border-2 border-gray-700 border-t-transparent rounded-full animate-spin duration-500"></span> */}
        <LoaderCircle strokeWidth={1} size={14} className="animate-spin" />
         Loading...
          {/* {displayText} */} 
        </p>
      </div>
    </div>
  );
};

export default Loader;
